import {memo, useCallback, useEffect, useRef, useState} from 'react'
import './index.css'
import {CommonColors} from '@utils/CommonStyles'
import {Box, Center, Flex, Icon, Image, Text, Textarea} from '@chakra-ui/react'
import useConversationPage, {
  MessageType,
  processMessages,
  processProgress,
} from './useConverstaionPage'
import {useLocation, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {
  FEATURE_NAME,
  FEATURE_REPORT_ERROR,
  LOCAL_STORAGE,
  PATH,
  SCREEN_REPORT_ERROR,
} from '@utils/Const'
import {clickEndConverstation} from '@redux/mixpanel/mixpanelSlice'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import {
  updateIsShowModalExitFlow,
  updateIsShowModalFeedbackRealTime,
  updateIsShowReportErrorForm,
} from '@redux/shared/shared'
import {updateIsShowConfirmClose} from '@redux/gym/gymSlice'
import {getFeedbackExitFlowType, isParamsValid} from '@utils'
import {ReactComponent as RotateLeft} from '@assets/svgs/rotate_left.svg'
import {updateConversationData} from '@redux/conversation/converstationSlice'
import IconSend from '@assets/svgs/send.svg'
import ItemBotMessage from './components/ItemBotMessage'
import GlobalTrans from '@components/GlobalTrans/GlobalTrans'
import FormSaveFolderModal from './components/FormSaveFolderModal'
import FormReportError from '@components/FormReportError'
import Close from '@assets/svgs/close.svg'
import ModalFeedbackRealTime from '@components/ModalFeedbackRealTime'
import ModalVerifyClose from './components/ModalVerifyClose'
import GlobalMic3 from '@components/GlobalMic3'
import BrandScore from './components/BrandScore'
import BoardItem from './components/BoardItem'
import ItemChatImage from './components/ItemChatImage'
import ItemChatVideo from './components/ItemChatVideo'
import ItemChatQuestion from '@pages/ConverstationPage/components/ItemChatQuestion'
import ItemSuggestionTable from './components/ItemSuggestionTable'
import ItemInfoBoard from './components/ItemInfoBoard'
import ItemSummary from './components/ItemSummary'
import ItemUserMessage from './components/ItemUserMessage'
import appRequest from '@apis/app'
import Progress from './components/Progress'
import {keyframes} from '@emotion/react'
import ModalTip from './components/ModalTip'
import {datadogRum} from '@datadog/browser-rum'

const slideUpAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

function ConverstationPage() {
  const {
    lesson_id,
    lesson_name,
    entry_point,
    task_id,
    task_type,
    feature_name,
  } = useLocation()?.state || {}
  const location = useLocation() || {}
  const [messages, setMessages] = useState<any[]>([])
  const [messagesResponse, setMessagesResponse] = useState<any[]>([])
  const {selectedTxtTrans, handleTextSelect} = useConversationPage()
  const conversationData = useSelector((state: any) => state.converstation)
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const [savedPhrase, setSavedPhrase] = useState<boolean>(false)
  const [feedbackKey, setFeedbackKey] = useState<string>('')
  const [screenReportError, setScreenReportError] = useState<string>('')
  const [featureReportError, setFeatureReportError] = useState<string>('')
  const [numberOfHideMessages, setNumberOfHideMessages] = useState<number>(0)
  const [isLoadingMsg, setIsLoadingMsg] = useState<boolean>(false)
  const [currentMessageIndex, setCurrentMessageIndex] = useState<number>(0)
  const [isPlayingAudio, setIsPlayingAudio] = useState<boolean>(false)
  const [audioUri, setAudioUri] = useState<string>('')
  const [isShowBtn, setIsShowBtn] = useState<boolean>(false)
  const [isLoadingMic, setIsLoadingMic] = useState<boolean>(false)
  const [textInput, setTextInput] = useState('')
  const [isShowInput, setIsShowInput] = useState(false)
  const [currentProgress, setCurrentProgress] = useState<any>(0)
  const audioRef = useRef<HTMLAudioElement>(null)
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isReloaded, setIsReloaded] = useState(false)
  const [audioFileUser, setAudioFileUser] = useState<any>(null)
  const tipRef = useRef<any>(null)

  // Kiểm tra params
  useEffect(() => {
    if (!isParamsValid([lesson_id])) {
      navigate(PATH.HOME)
    }
  }, [])

  // Xử lý phát audio
  useEffect(() => {
    try {
      if (audioUri && audioRef.current && !isReloaded) {
        audioRef.current.play()
      }
    } catch (error) {
      console.log('error', error)
      datadogRum.addAction('conversation_error_play_audio', {
        lesson_id,
        session_id: conversationData?.session_id,
        step: conversationData?.step,
        audioUri,
      })
    }
  }, [audioUri, isReloaded])

  useEffect(() => {
    const progressId = messages[messages?.length - 1]?.progress_id
    const progressIndex = conversationData?.progress?.findIndex(
      (item: any) => item.progress_id === progressId,
    )
    if (progressIndex === -1) return
    setCurrentProgress(progressIndex)
  }, [messages])

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [messages, isLoadingMsg])

  // Khởi tạo session hội thoại
  useEffect(() => {
    const initSession = async () => {
      try {
        const res = await appRequest.initConversation(lesson_id)
        const rawMessages = res?.data?.data?.messages
        const messagesResult = processMessages(rawMessages)
        setMessagesResponse(messagesResult)

        datadogRum.addAction('conversation_init_session', {
          lesson_id,
          session_id: res?.data?.data?.session_id,
        })

        dispatch(
          updateConversationData({
            session_id: res?.data?.data?.session_id,
            step: res?.data?.data?.step,
            is_has_next_messages: res?.data?.data?.has_next_messages,
            is_hide_user_messages: res?.data?.data?.is_hide_user_messages,
            is_finish: res?.data?.data?.is_finish,
          }),
        )
      } catch (error) {
        console.log('error,', error)
      } finally {
        setIsLoadingMsg(false)
      }
    }
    initSession()

    const getProgress = async () => {
      const res = await appRequest.getProgressBar({lesson_id})
      const progress = res?.data?.data
      dispatch(
        updateConversationData({
          progress: progress,
        }),
      )
    }
    getProgress()
  }, [])

  // Hiển thị tin nhắn tiếp theo
  useEffect(() => {
    const showNextMessage = async () => {
      if (currentMessageIndex >= messagesResponse.length) return

      const currentMsg = messagesResponse[currentMessageIndex]
      setMessages(prev => [...prev, currentMsg])
      if (currentMsg.audio) {
        setAudioUri(currentMsg.audio)
        setIsPlayingAudio(true)
      } else {
        await new Promise(resolve => setTimeout(resolve, 1000))
        setCurrentMessageIndex(prev => prev + 1)
        if (currentMessageIndex === messagesResponse.length - 1) {
          setIsShowBtn(true)
        }
      }
    }

    if (!isPlayingAudio) {
      showNextMessage()
    }
  }, [currentMessageIndex, messagesResponse, isPlayingAudio])

  // Hiển thị modal tip
  useEffect(() => {
    try {
      const isShowTip = sessionStorage.getItem(
        LOCAL_STORAGE.IS_SHOW_TIP_TRANSLATE,
      )

      if (
        messages[messages.length - 1]?.message_type === MessageType.score &&
        !isShowTip
      ) {
        tipRef.current.onOpen()
        sessionStorage.setItem(LOCAL_STORAGE.IS_SHOW_TIP_TRANSLATE, 'true')
      }
    } catch (error) {}
  }, [messages])

  // Xử lý báo lỗi
  useEffect(() => {
    if (feature_name === FEATURE_NAME.LESSON_PART_ONE) {
      setScreenReportError(SCREEN_REPORT_ERROR.LESSON_PART_1)
      setFeatureReportError(FEATURE_REPORT_ERROR.LESSON_PART_1)
    }
    if (feature_name === FEATURE_NAME.LESSON_PART_TWO) {
      setScreenReportError(SCREEN_REPORT_ERROR.LESSON_PART_2)
      setFeatureReportError(FEATURE_REPORT_ERROR.LESSON_PART_2)
    }
  }, [])

  // Xử lý feedback
  useEffect(() => {
    if (
      feedbackKey &&
      !dataFeedbackOverview?.feedback_data[feedbackKey]?.is_completed
    ) {
      dispatch(updateIsShowModalFeedbackRealTime(true))
    }
  }, [feedbackKey])

  // Xử lý feedback sau khi có brainstorming
  useEffect(() => {
    if (conversationData?.idea_board && task_type === 'LESSON_PART_TWO') {
      setFeedbackKey('AFTER_FIRST_BRAINSTORMING')
    }
  }, [conversationData])

  // Xử lý đếm số lần tin nhắn bị ẩn
  useEffect(() => {
    if (
      conversationData?.is_hide_user_messages &&
      task_type === 'LESSON_PART_TWO'
    ) {
      setNumberOfHideMessages(prev => prev + 1)
    }
  }, [conversationData])

  // Xử lý feedback sau khi hoàn thành brainstorming
  useEffect(() => {
    if (numberOfHideMessages === 3) {
      setFeedbackKey('AFTER_FIRST_BRAINSTORMING')
    }
  }, [numberOfHideMessages])

  // Xử lý kích thước textarea
  useEffect(() => {
    handleResize()
  }, [textInput])

  useEffect(() => {
    const locationKey = sessionStorage.getItem('locationKey')
    if (location.key === locationKey) {
      setIsReloaded(true)
    } else {
      sessionStorage.setItem('locationKey', location.key)
    }
  }, [])

  const handleResize = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`
    }
  }

  // Reset function
  const handleStart = () => {
    setIsReloaded(false)
  }

  const handleEndAudio = () => {
    setIsPlayingAudio(false)
    setCurrentMessageIndex(prev => prev + 1)
    setAudioUri('')
    if (currentMessageIndex === messagesResponse.length - 1) {
      setIsShowBtn(true)
    }
  }

  const sendAudio = async (blob: any) => {
    try {
      setIsLoadingMic(true)
      if (blob?.size < 10000) return ''
      let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
      setAudioFileUser(file)
      const formData = new FormData()
      formData.append('audio-file', file)
      formData.append('session-id', conversationData?.session_id)
      const res = await appRequest.sendUserAudio(formData)
      return res?.data?.data?.text || ''
    } catch (error) {
      console.log('error,', error)
      datadogRum.addAction('conversation_error_send_audio', {
        lesson_id,
        session_id: conversationData?.session_id,
        step: conversationData?.step,
      })
    } finally {
      setIsLoadingMic(false)
    }
  }

  const handleBack = () => {
    setIsShowInput(false)
    setTextInput('')
  }

  const handleSendText = useCallback(
    async (isContinue?: boolean, isRetry: boolean = false) => {
      console.log('isRetry', isRetry)
      try {
        setIsShowBtn(false)
        setIsShowInput(false)
        setIsLoadingMsg(true)
        const params = {
          data: {
            user_message: textInput,
            message_type: 'text',
          },
          session_id: conversationData.session_id,
        }
        const query = {
          lesson_id: conversationData.lesson_id,
          step: conversationData.step,
        }

        const userMessage = {
          message_type: MessageType.text,
          message: textInput,
          isUser: true,
        }

        if (!isContinue && !isRetry) {
          setMessages((prev: any) => [...prev, userMessage])
        }
        const res = await appRequest.getResponseConversation(params, query)
        const rawMessages = res?.data?.data?.messages
        const messagesResult = processMessages(rawMessages)
        setMessagesResponse((prev: any) => [...prev, ...messagesResult])

        dispatch(
          updateConversationData({
            session_id: res?.data?.data?.session_id,
            step: res?.data?.data?.step,
            is_has_next_messages: res?.data?.data?.has_next_messages,
            is_hide_user_messages: res?.data?.data?.is_hide_user_messages,
            is_finish: res?.data?.data?.is_finish,
          }),
        )
      } catch (error) {
        console.log('error,', error)
        datadogRum.addAction('conversation_error_send_text', {
          lesson_id,
          session_id: conversationData?.session_id,
          step: conversationData?.step,
        })
        // Retry once if this is not already a retry attempt
        if (!isRetry) {
          await handleSendText(isContinue, true)
          return
        }

        const botMessage = {
          message_type: MessageType.text,
          message: 'Hãy thử lại lần nữa nhé!',
          isUser: false,
        }

        setMessages((prev: any) => [...prev, botMessage])
        setIsShowBtn(true)
      } finally {
        setIsLoadingMsg(false)
      }
    },
    [conversationData, textInput],
  )

  const handleContinue = async () => {
    datadogRum.addAction('conversation_continue', {
      lesson_id,
      session_id: conversationData?.session_id,
      step: conversationData?.step,
    })
    handleSendText(true)
  }

  const handleClickClose = () => {
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data[
        getFeedbackExitFlowType(location.pathname)
      ]?.is_completed
    ) {
      dispatch(updateIsShowModalExitFlow(true))
    } else {
      dispatch(updateIsShowConfirmClose(true))
    }
  }

  const handleRecordingComplete = async (blob: any) => {
    let text = await sendAudio(blob)
    setTextInput(text)
    setIsShowInput(true)
  }

  const handleFinish = () => {
    datadogRum.addAction('conversation_finish', {
      lesson_id,
      session_id: conversationData?.session_id,
    })
    if (entry_point === 'ROADMAP') {
      navigate(PATH.ROADMAP_SUMMARY, {
        state: {
          task_id: task_id,
          entry_point: entry_point,
        },
      })
    } else {
      navigate(-1)
      // @ts-ignore
      dispatch(clickEndConverstation())
    }
  }

  const renderHeader = () => {
    return (
      <Flex w={'100%'} justifyContent={'space-between'} alignItems={'center'}>
        <Image
          w={{base: '20px', md: '24px'}}
          h={{base: '20px', md: '24px'}}
          src={Close}
          onClick={handleClickClose}
          cursor={'pointer'}
        />
        <Text fontSize={{base: '14px', md: '20px'}} fontWeight={'600'}>
          {lesson_name}
        </Text>
        <Icon
          w={{base: '20px', md: '24px'}}
          h={{base: '20px', md: '24px'}}
          viewBox="0 0 24 24"
          cursor={'pointer'}
          sx={{
            path: {
              fill: '#000000',
            },
          }}
          onClick={() => {
            dispatch(updateIsShowReportErrorForm(true))
          }}>
          <ExclamationCircle />
        </Icon>
      </Flex>
    )
  }

  const renderProgressBar = () => {
    return (
      <Box w={'100%'} alignSelf={'center'} mt={{base: '12px', md: '24px'}}>
        <Progress
          steps={processProgress(conversationData?.progress)}
          currentIndex={currentProgress}
          currentPercent={0}
        />
      </Box>
    )
  }

  const renderFooter = () => {
    return (
      <Center
        minH={{base: '100px', md: '120px'}}
        py={{base: '12px', md: '16px'}}>
        {isShowBtn &&
          (conversationData?.is_finish ? (
            <Text
              bg={CommonColors.primary}
              color={CommonColors.white}
              fontSize={'16px'}
              fontWeight={'600'}
              borderRadius={'100px'}
              padding={'16px 24px'}
              cursor={'pointer'}
              onClick={handleFinish}>
              Kết thúc
            </Text>
          ) : conversationData?.is_has_next_messages ? (
            <Text
              bg={CommonColors.primary}
              color={CommonColors.white}
              fontSize={'16px'}
              fontWeight={'600'}
              borderRadius={'100px'}
              padding={'16px 24px'}
              cursor={'pointer'}
              onClick={handleContinue}>
              Tiếp tục
            </Text>
          ) : isShowInput ? (
            <Flex
              gap={{base: '12px', md: '20px'}}
              alignItems={'center'}
              alignSelf={'center'}
              w={{base: '100%', md: 'auto'}}>
              <Center
                flexShrink={0}
                w={{base: '40px', md: '50px'}}
                h={{base: '40px', md: '50px'}}
                borderRadius={'50%'}
                shadow={'md'}>
                <Icon
                  as={RotateLeft}
                  w={{base: '24px', md: '24px'}}
                  h={{base: '24px', md: '24px'}}
                  cursor={'pointer'}
                  onClick={handleBack}></Icon>
              </Center>
              <Flex
                flexDirection={'row'}
                alignItems={'center'}
                gap={{base: '12px', md: '16px'}}
                bg={CommonColors.shadow1}
                borderRadius={'16px'}
                p={{base: '12px', md: '16px'}}
                minH={'52px'}
                w={{base: '100%', md: '500px'}}>
                <Textarea
                  borderWidth={0}
                  outline={'none'}
                  p={'0px'}
                  textColor={CommonColors.white}
                  value={textInput}
                  rows={1}
                  resize="vertical"
                  ref={textAreaRef}
                  fontSize={'16px'}
                  _focus={{
                    outline: 'none',
                    boxShadow: 'none',
                  }}
                  onKeyDown={event => {
                    if (event.keyCode === 13 && textInput?.trim()) {
                      if (
                        task_type === 'LESSON_PART_ONE' &&
                        conversationData?.step === 'step4_pty1'
                      ) {
                        setFeedbackKey('FIRST_ANSWER_AFTER_SUGGESTION')
                      }
                      handleSendText()
                      setTextInput('')
                      setIsShowInput(false)
                    }
                  }}
                  onInput={handleResize}
                  onChange={event => setTextInput(event.target.value)}
                />
                <Image
                  w={{base: '16px', md: '24px'}}
                  h={{base: '16px', md: '24px'}}
                  cursor={textInput?.trim() ? 'pointer' : 'not-allowed'}
                  opacity={textInput?.trim() ? 1 : 0.5}
                  src={IconSend}
                  onClick={() => {
                    if (textInput?.trim()) {
                      if (
                        task_type === 'LESSON_PART_ONE' &&
                        conversationData?.step === 'step4_pty1.1'
                      ) {
                        setFeedbackKey('FIRST_ANSWER_AFTER_SUGGESTION')
                      }
                      handleSendText()
                    }
                  }}
                />
              </Flex>
            </Flex>
          ) : (
            <GlobalMic3
              handleRecordingComplete={handleRecordingComplete}
              isLoading={isLoadingMic}
            />
          ))}
      </Center>
    )
  }

  return (
    <Flex
      p={{base: '16px', md: '32px'}}
      flexDirection={'column'}
      height={'100dvh'}>
      {isReloaded ? (
        <Center height="100%" flexDirection="column">
          <Box textAlign="center" mb={6}>
            <Text fontSize={{base: '24px', md: '32px'}} fontWeight="700" mb={3}>
              Oops! Trang đã được làm mới
            </Text>
            <Text fontSize={{base: '14px', md: '16px'}} color="gray.600">
              Hãy bắt đầu lại cuộc trò chuyện của bạn
            </Text>
          </Box>

          <Box
            as="button"
            bg={CommonColors.primary}
            color={CommonColors.white}
            fontSize={{base: '16px', md: '18px'}}
            fontWeight="600"
            borderRadius="100px"
            px={8}
            py={4}
            cursor="pointer"
            transition="all 0.2s"
            _hover={{
              transform: 'translateY(-2px)',
              boxShadow: 'lg',
            }}
            onClick={handleStart}>
            <Flex align="center" gap={2}>
              <Text fontWeight={'600'}>Bắt đầu</Text>
            </Flex>
          </Box>
        </Center>
      ) : (
        <Flex
          h={'100%'}
          flexDirection={'column'}
          w={'100%'}
          maxW={'1280px'}
          mx={'auto'}>
          {renderHeader()}
          {renderProgressBar()}
          <Flex
            ref={scrollContainerRef}
            flex={1}
            flexDirection={'column'}
            overflow={'auto'}
            w={'100%'}
            bg={{base: 'transparent', md: 'white'}}
            mt={{base: '16px', md: '24px'}}
            borderRadius={{base: 0, md: '24px'}}
            gap={{base: '12px', md: '16px'}}
            p={{base: 0, md: '24px'}}
            pb={'16px'}
            sx={{
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
            onMouseUp={handleTextSelect}>
            {messages.map((message: any, index: number) => (
              <Box
                key={index}
                animation={`${slideUpAnimation} 0.3s ease-out`}
                sx={{
                  '@media screen and (prefers-reduced-motion: reduce)': {
                    animation: 'none',
                  },
                }}>
                <MessageItem
                  message={message}
                  index={index}
                  isHidden={
                    conversationData?.is_hide_user_messages &&
                    index != messages.length - 1
                  }
                  audioFileUser={audioFileUser}
                />
              </Box>
            ))}
            {isLoadingMsg && (
              <Flex alignItems={'center'}>
                <Box
                  bg={'white'}
                  borderRadius={'24px'}
                  boxShadow={
                    '0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05)'
                  }
                  px={'40px'}
                  py={'24px'}>
                  <Box className="loading-message"></Box>
                </Box>
              </Flex>
            )}
          </Flex>
          {renderFooter()}
        </Flex>
      )}
      <ModalTip ref={tipRef} />
      <GlobalTrans
        textTrans={selectedTxtTrans}
        savedPhrase={savedPhrase}
        setSavedPhrase={setSavedPhrase}
      />
      <FormSaveFolderModal setSavedPhrase={setSavedPhrase} />
      {featureReportError && screenReportError && (
        <FormReportError
          feature={featureReportError}
          screen={screenReportError}
        />
      )}
      <ModalFeedbackRealTime feedbackKey={feedbackKey} />
      <ModalVerifyClose />
      <audio ref={audioRef} src={audioUri} onEnded={handleEndAudio} />
    </Flex>
  )
}

export default ConverstationPage

const MessageItem = memo(
  ({
    message,
    index,
    isHidden,
    audioFileUser,
  }: {
    message: any
    index: number
    isHidden: boolean
    audioFileUser: any
  }) => {
    const renderMessage = () => {
      switch (message?.message_type) {
        case MessageType.text: {
          if (message?.isUser) {
            return (
              <ItemUserMessage
                key={`bot-${index}`}
                // isLoading={isLoading}
                audioFileUser={audioFileUser}
                isHidden={isHidden}
                text={message?.message}
                message={message}
              />
            )
          }
          return <ItemBotMessage key={`user-${index}`} message={message} />
        }
        case MessageType.score: {
          return <BrandScore key={`score-${index}`} message={message} />
        }
        case MessageType.board: {
          return <BoardItem key={`board-${index}`} message={message} />
        }
        case MessageType.image: {
          return <ItemChatImage key={`image-${index}`} url={message?.message} />
        }
        case MessageType.video: {
          return <ItemChatVideo key={`video-${index}`} message={message} />
        }
        case MessageType.question: {
          return (
            <ItemChatQuestion key={`question-${index}`} message={message} />
          )
        }
        case MessageType.suggestionTable: {
          return (
            <ItemSuggestionTable key={`table-${index}`} message={message} />
          )
        }
        case MessageType.infoBoard: {
          return <ItemInfoBoard key={`info-board-${index}`} message={message} />
        }
        case MessageType.summary: {
          return <ItemSummary key={`user-${index}`} message={message} />
        }
        default: {
          return <></>
        }
      }
    }

    return renderMessage()
  },
)
